import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from './data/app-config.service';

const urlAPI = 'https://enlinea.trijaem.ml/api/auth/';
// const urlAPI = 'https://api.apilaravel.ml/api/auth/';

const httpOption = {
    headers: new HttpHeaders().set('Content-Type', 'application/json' )
};


@Injectable({providedIn: 'root'})
export class LoginService {

    private urlLogin: string;
    
    constructor(private http: HttpClient, private settings: AppConfigService) {
        this.urlLogin = this.settings.getUrlApi() + 'auth/';
    }

    getTokenLogin = (userData) => {
        return this.http.post(this.urlLogin+ 'login', JSON.stringify(userData), httpOption);              
    }

    async login(credentials) {
        let response = false;
        console.table("Credentials : ", credentials);
        if( credentials.email    === 'ego@go.com' && 
            credentials.password === 'uno') {
            response = true;
        }
        return {
            typeUser: 'superadmin',
            user: 'Adm',
            access: response
        }
    }
    
    registerUser = (data) => {
        const urlSignup = this.urlLogin + 'signup';
        // return this.http.post(urlSignup, JSON.stringify(data), httpOption);


        let optionHeaders   = this.settings.getHeadersMultipart();
        const dataUser = this._toFormData(data);
        return this.http.post(urlSignup, dataUser, optionHeaders);
    }
    
    registerAdviser = (data) => {
        console.log('datooososss',data);
        //const urlSignup = this.settings.getUrlApi() + 'advisories';
        const httpOptions = this.settings.getHeadersMultipart();
        if(sessionStorage.getItem('tk') != null){
            console.log('privada');
            return this.http.post(this.settings.getUrlApi() + 'advisories', data, httpOptions);
        }else{
            console.log('publica');
            return this.http.post(this.settings.getUrlApi() + 'asesorias', data, httpOptions);
        }
        
    }

    recoverCredential = (mail) => {
        const urlRecover = this.urlLogin + 'password/email';
        return this.http.post(urlRecover, JSON.stringify(mail), httpOption);
    }

    resetCredential = (data) => {
        const urlRecover = this.urlLogin + 'password/reset';
        return this.http.post(urlRecover, JSON.stringify(data), httpOption);
    }

    getUser = () => {
        this._resetFlags();
        const httpOptions = this.settings.getHeadersJson();
        return this.http.get(this.urlLogin + 'user', httpOptions)
    }

    logOut() {
        this._resetFlags();
        const httpOptions = this.settings.getHeadersJson();
        return this.http.get(this.urlLogin + 'logout', httpOptions)
    }

    _resetFlags = () => {
        console.log('reset flags');
        sessionStorage.setItem('promotions', 'false');
        sessionStorage.setItem('agreements', 'false');
        sessionStorage.setItem('notifications', 'false');
    }

    _toFormData(data) {
        const formData = new FormData();
        formData.append('tp', data.tp); 
        formData.append('name', data.name);
        formData.append('paterno', data.paterno);
        formData.append('materno', data.materno);
        formData.append('curp', data.curp);
        formData.append('ine', data.ine);
        formData.append('telefono', data.telefono);
        formData.append('email', data.email);
        formData.append('password', data.password);
        formData.append('muni', data.muni);
        formData.append('tpau', data.tpau);
        formData.append('auto', data.auto);
        formData.append('password_confirmation', data.password_confirmation);
        return formData;
    }

}